import * as React from 'react'
import type { SVGProps } from 'react'
function SvgGeburtenTodesfalleFlatline2470359645072(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 246.7 124.9"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M135.5,65.5c0.8,0.2,1.7,0.2,2.4-0.2c0.8-0.4,1.3-1.1,1.6-1.9L155,12.2l19.3,69.7c0.4,1.4,1.6,2.3,3.1,2.3h12.5l8,12.3 c1,1.5,2.7,2.5,4.5,2.5h0v-0.3l0,0.3c1.9,0,3.6-1,4.6-2.6l7.5-12.2h29c1.8,0,3.2-1.4,3.2-3.2c0-1.8-1.4-3.2-3.2-3.2h-30.8 c-1.1,0-2.1,0.6-2.7,1.5l-7.6,12.4l-8.1-12.5c-0.6-0.9-1.6-1.5-2.7-1.5h-11.8L159.2,3.1c-0.5-1.8-2.1-3-4-3.1c-1.9,0-3.5,1.2-4,3 l-17.7,58.6c-0.2,0.8-0.2,1.7,0.2,2.4C134,64.7,134.7,65.3,135.5,65.5z" />
        <path d="M61.2,82.1L70.3,57l20.3,65c0.5,1.5,1.7,2.6,3.3,2.9l0,0.1h0.7c1.6,0,3.1-1,3.8-2.5l17.4-38.2h14.9c1.8,0,3.2-1.4,3.2-3.2 c0-1.8-1.4-3.2-3.2-3.2h-17c-1.2,0-2.4,0.7-2.9,1.9L95,114.5L74.5,48.8c-0.5-1.7-2.1-2.9-3.9-2.9c-1.8,0-3.4,1.1-4,2.7L55.9,77.8 H29.2l-9.6-10c-1-1.1-2.4-1.7-3.9-1.7c-1.4,0-2.8,0.6-3.8,1.6l-11,11c-1.2,1.3-1.2,3.3,0,4.5c1.3,1.2,3.3,1.2,4.5,0L15.7,73 l9.8,10.2c0.6,0.6,1.4,1,2.3,1h30.3C59.5,84.2,60.7,83.4,61.2,82.1z" />
      </g>
    </svg>
  )
}
export default SvgGeburtenTodesfalleFlatline2470359645072
